// Single source of truth for the subscription plan details shown on the
// Landing Page pricing section and the Choose Plan page. Keep this in sync
// with Stripe pricing when the backend integration lands — the `id` field is
// meant to double as the plan identifier passed through the subscription flow.
export const SUBSCRIPTION_PLANS = [
  {
    id: "basic",
    name: "Basic",
    description: "Perfect for getting started",
    price: "$7",
    priceSuffix: "/screen/month",
    badge: null,
    highlighted: false,
    features: [
      "Up to 1 Screen",
      "Basic content upload",
      "Standard support",
      "Basic analytics",
    ],
    ctaLabel: "Contact Sales",
    buttonClassName:
      "w-full border border-input bg-background h-11 rounded-md px-8 w-full bgs",
  },
  {
    id: "advanced",
    name: "Advanced",
    description: "For growing businesses",
    price: "$10",
    priceSuffix: "/screen/month",
    badge: "Most Popular",
    highlighted: true,
    features: [
      "2 or more Screens",
      "Unlimited content upload",
      "Priority support",
      "Advanced analytics",
      "Campaign scheduling",
      "Multi-location management",
    ],
    ctaLabel: "Get Started",
    buttonClassName:
      "w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-md hover:shadow-lg transition-all h-11 rounded-md px-8 w-full",
  },
  {
    id: "premium",
    name: "Premium",
    description: "Complete solution for enterprises",
    price: "$99",
    priceSuffix: "/month",
    badge: null,
    highlighted: false,
    features: [
      "Unlimited number of screens",
      "24 x 7 Chat support",
      "Website creation (upto 3 pages) and maintenance",
      "Digital Menu public URL",
      "Scheduling content",
    ],
    ctaLabel: "Get Started",
    buttonClassName:
      "w-full border border-input bg-background h-11 rounded-md px-8 w-full bgs",
  },
];

export default SUBSCRIPTION_PLANS;
